import { EmitOptions } from '@/models/emit-options.enum';

export default class AccordionCode {
	constructor(private emit: (name: string) => void) {}

	public toggleAccordion(): void {
		this.emit(EmitOptions.TOGGLE_ACCORDION);
	}
}
